export default __webpack_public_path__ + "static/media/h2o-svgrepo-com.a5112237.svg";